import httpClient from "@/services/httpClient"
import { formatData, encodeRequestParameters } from "@/services/request"
import { microsoftSSOFormat } from "@/services/formats"

/**
 * MICROSOFT SSO CONNECTIONS
 */
export async function getMicrosoftSSOLink() {
    return await httpClient.get("/auth/sso")
}
